import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import { StyledTab, StyledTabs } from '@selfserve/react-ui';
import { useCustomSearchParams } from '@selfserve/react-hooks';

import { AdminVersions } from './admin-versions';

import { enterpriseTabs } from '../constants/enterprise-tabs';

import { StyledPageTitle } from '../ui/admin-styled-components';
import { AdminErrors } from './admin-errors';

const StyledAdminEnterpriseContentContainer = styled('div')(
  ({ theme }: { theme?: any }) => ({
    padding: '16px',
  })
);

const AdminEnterprise = () => {
  const { t } = useTranslation();
  const { productFamily } = useParams();
  const [query, setQuery] = useCustomSearchParams();
  const tab = useMemo(() => (query['tab'] as string) || '', [query]);

  useEffect(() => {
    if (!tab) {
      setQuery(
        (prevQuery) => ({
          ...prevQuery,
          tab: enterpriseTabs.VERSIONS,
        }),
        { replace: true }
      );
    }
  }, [tab]);

  const handleSetTab = useCallback(
    (value: string) => () => {
      setQuery((prevQuery) => ({
        ...prevQuery,
        tab: value,
      }));
    },
    [productFamily, setQuery]
  );

  return (
    <div>
      <StyledPageTitle isSmall>{t('common.admin-enterprise')}</StyledPageTitle>
      <StyledTabs value={tab}>
        <StyledTab
          value={enterpriseTabs.VERSIONS}
          label={t('common.versions')}
          onClick={handleSetTab(enterpriseTabs.VERSIONS)}
          isSmall={false}
          smallMargin
        />
        <StyledTab
          value={enterpriseTabs.ERRORS}
          label={t('common.errors')}
          onClick={handleSetTab(enterpriseTabs.ERRORS)}
          isSmall={false}
          smallMargin
        />
      </StyledTabs>
      <StyledAdminEnterpriseContentContainer>
        {(() => {
          switch (tab) {
            default:
            case enterpriseTabs.VERSIONS:
              return <AdminVersions />;
            case enterpriseTabs.ERRORS:
              return <AdminErrors />;
          }
        })()}
      </StyledAdminEnterpriseContentContainer>
    </div>
  );
};

export { AdminEnterprise };
